<template>
  <button
    :class="{ 'btn text-nowrap': true, 'btn-white': !reconciled, 'btn-primary': reconciled }"
    @click.prevent="reconciled = !reconciled"
  >
    <i
      class="far fa-fw fa-square"
      v-if="!reconciled"
    ></i>
    <i
      class="far fa-fw fa-check-square"
      v-if="reconciled"
    ></i>
    <span
      v-if="!hideLabel"
      class="ml-1"
    >
      {{ reconciled ? 'Reconciled' : 'Reconcile' }}
    </span>
  </button>
</template>

<script>
import alertify from 'alertify.js'
import axios from 'axios'

export default {
  name: 'ReoncileLeadButton',
  props: {
    id: Number,
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      reconciled: false
    }
  },
  watch: {
    reconciled () {
      if (this.reconciled) {
        this.reconcile()
      } else {
        this.undo()
      }
    }
  },
  methods: {
    reconcile () {
      axios.post(`/leads/${this.id}/reconciled`).then(() => {
        alertify.closeLogOnClick().log('Saved. <a href="#" class="text-primary ml-2 text-underline">UNDO</a>', () => {
          this.reconciled = false
        })
      }).catch(() => {
        alertify.error('Failed to save reconciliation.')
      })
    },
    undo () {
      axios.delete(`/leads/${this.id}/reconciled`).then(() => {
        this.reconciled = false
        alertify.log('Undone.')
      }).catch(() => {
        alertify.error('Failed to undo reconciliation.')
      })
    }
  }
}
</script>